/** Client-side Creator Intelligence filters (must match PerfHubCreatorIntelligence). */

export const INTEL_FILTERS_FALLBACK = [
  { id: 'all', label: 'All creators' },
  { id: 'rebook', label: 'Re-book picks' },
  { id: 'ugc', label: 'UGC suggested' },
  { id: 'phase2', label: 'Phase 2 recommended' },
  { id: 'improving', label: 'Improving' },
];

export function filterIntelCreators(creators, filterId) {
  const list = creators || [];
  const f = filterId || 'all';
  if (f === 'rebook') return list.filter((c) => (c.rebook_score || 0) >= 60);
  if (f === 'ugc') return list.filter((c) => c.ugc_suggested);
  if (f === 'phase2' || f === 'phase-2') return list.filter((c) => c.phase2_recommended);
  if (f === 'improving') return list.filter((c) => c.trend === 'improving');
  return list;
}
